import { render, staticRenderFns } from "./DivisionsList.vue?vue&type=template&id=75456b9a&lang=pug"
import script from "./DivisionsList.vue?vue&type=script&lang=js"
export * from "./DivisionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75456b9a')) {
      api.createRecord('75456b9a', component.options)
    } else {
      api.reload('75456b9a', component.options)
    }
    module.hot.accept("./DivisionsList.vue?vue&type=template&id=75456b9a&lang=pug", function () {
      api.rerender('75456b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/data_strategy/components/DivisionsList.vue"
export default component.exports